import { Product } from '@customTypes/product'
import { isValidProduct } from './helpers'

export const setProduct = async (product: Product) => {
  try {
    await isValidProduct(product)
    const { store } = await import('@store/index')
    const { setVmProducts } = await import('@store/reducers/products')

    store.dispatch(setVmProducts([product]))
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Invalid product data', e)
  }
}
